// This import loads the firebase namespace along with all its type information.
import GameConfig from './game-config-model'

export async function load_gameConfigs(): Promise<GameConfig[]> {
  throw 'Not implemented'
}

export async function delete_gameConfig(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_gameConfig(): Promise<GameConfig> {
  throw 'Not implemented'
}
